export default "__VITE_ASSET__Cyq6JRUM__"